module.exports = __webpack_public_path__ + "static/media/client-logo-3.3952e204.jpg";